import React from "react";

const AccordionClose = ({ width, height }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || 35}
      height={height || 34}
      viewBox="0 0 35 34"
      fill="none"
    >
      <g clipPath="url(#clip0_255_4106)">
        <foreignObject x="-6.92773" y="-6.99951" width="48" height="48">
          <div
            xmlns="http://www.w3.org/1999/xhtml"
            style={{
              backdropFilter: "blur(3.5px)",
              clipPath: "url(#bgblur_1_255_4106_clip_path)",
              height: "100%",
              width: "100%",
            }}
          ></div>
        </foreignObject>
        <circle
          data-figma-bg-blur-radius="7"
          cx="17.0723"
          cy="17.0005"
          r="17"
          fill="#150B3B"
        />
        <path
          d="M23.9911 20.4724L17.5328 14.3481L11.0744 20.4724C10.9787 20.563 10.865 20.6349 10.7399 20.684C10.6149 20.7331 10.4808 20.7583 10.3454 20.7583C10.21 20.7583 10.076 20.7331 9.95088 20.684C9.8258 20.6349 9.71215 20.563 9.61642 20.4724C9.52068 20.3818 9.44474 20.2742 9.39293 20.1557C9.34112 20.0373 9.31445 19.9104 9.31445 19.7822C9.31445 19.654 9.34112 19.5271 9.39293 19.4087C9.44474 19.2903 9.52068 19.1827 9.61642 19.092L16.8038 12.2873C16.8992 12.1962 17.0128 12.1238 17.1379 12.0745C17.263 12.0251 17.3972 11.9997 17.5328 11.9997C17.6683 11.9997 17.8025 12.0251 17.9276 12.0745C18.0527 12.1238 18.1663 12.1962 18.2618 12.2873L25.4491 19.092C25.6424 19.2751 25.7511 19.5233 25.7511 19.7822C25.7511 20.0411 25.6424 20.2894 25.4491 20.4724C25.2557 20.6555 24.9935 20.7583 24.7201 20.7583C24.4467 20.7583 24.1844 20.6555 23.9911 20.4724Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath
          id="bgblur_1_255_4106_clip_path"
          transform="translate(6.92773 6.99951)"
        >
          <circle cx="17.0723" cy="17.0005" r="17" />
        </clipPath>
        <clipPath id="clip0_255_4106">
          <rect
            width="34.9278"
            height="34"
            fill="white"
            transform="translate(0.0722656 0.000488281)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default AccordionClose;
